export const LS_CART_KEY = 'cart:v1';
export const CART_DEFAULT_MAX_QUANTITY = 10;
